/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type models_DunningStageSettings = {
    /**
     * only set on final_notice
     */
    after_final?: models_DunningStageSettings.after_final;
    /**
     * only used when after_final == 'continue'
     */
    continue_interval_days?: number;
    enabled?: boolean;
    offset_days?: number;
    stage: models_DunningStageSettings.stage;
};
export namespace models_DunningStageSettings {
    /**
     * only set on final_notice
     */
    export enum after_final {
        STOP = 'stop',
        CONTINUE = 'continue',
    }
    export enum stage {
        REMINDER_1 = 'reminder_1',
        REMINDER_2 = 'reminder_2',
        REMINDER_3 = 'reminder_3',
        FINAL_NOTICE = 'final_notice',
    }
}

